module.exports = __webpack_public_path__ + "media/images/flags/tr-69a0293b2c67b5b1cd2fee10843e6cd8.svg";